import React from 'react';
import { WBFullScreenModal } from '@admiin-com/ds-web';
import { useTranslation } from 'react-i18next';
import { Contact, CreateContactInput } from '@admiin-com/ds-graphql';
import { ContactsCreateForm } from '../ContactDetail/ContactsCreateForm';
export interface ContactCreateModalProps {
  open: boolean;
  entityId?: string;
  onSuccess?: (contact: Contact) => void;
  handleCloseModal: () => void;
  selected?: CreateContactInput | null;
  ocrCreate?: boolean;
}

export function ContactCreateModal({
  open,
  onSuccess,
  entityId,
  handleCloseModal,
  selected,
  ocrCreate,
}: ContactCreateModalProps) {
  const { t } = useTranslation();

  return (
    <WBFullScreenModal
      leftToolbarIconProps={{
        onClick: () => handleCloseModal(),
      }}
      leftToolbarIconTitle={t('back', { ns: 'contacts' })}
      onClose={handleCloseModal}
      title={t(
        selected && 'id' in selected ? 'updateContact' : 'createContact',
        {
          ns: 'contacts',
        }
      )}
      open={open}
    >
      <ContactsCreateForm
        entityId={entityId}
        selected={selected}
        onSubmitted={(contact) => {
          onSuccess && onSuccess(contact);
          handleCloseModal();
        }}
        ocrCreate={ocrCreate}
      />
    </WBFullScreenModal>
  );
}
